export enum InstructionTab {
  Interface = 'interface',
  Api = 'api',
  Faq = 'faq',
}

export type InstructionTabItem = {
  id: InstructionTab;
  label: string;
};

export type ApiMethod = {
  method: string;
  description: string;
};

export type ApiEndpointSection = {
  title: string;
  request: string;
  summary: string;
  headers?: string;
  body?: string;
  response?: string;
};

export type FaqItem = {
  question: string;
  answers: string[];
};

export type FaqBlock = {
  title: string;
  items: FaqItem[];
};
